<app-settings-base
  title="{{'companyInfoSettings.title' | translate}}"
  description="{{'companyInfoSettings.text' | translate}}"
  details="{{'companyInfoSettings.detailsHeader' | translate}}"
  sourceUrl="/setting/company-info">
</app-settings-base>
